/* eslint-disable react/no-array-index-key */
import { Trans } from '@lingui/macro';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles } from '@material-ui/core';
import { useEffect, useRef, useState } from 'react';
import { useDataService } from '../../services/ApiDataService';
import { useRequestState } from '../../utilities/Hooks';

export const BANNER_URL = '/ngp/v2/banner';

const useStyles = makeStyles(() => ({
    bannerText: {
        fontFamily: 'monospace',
        whiteSpace: 'pre',
    },
}));

export function LoginBannerDialog({ onHide }) {
    const classes = useStyles();
    const [show, setShow] = useState(true);
    const { banner } = useWarningBanner();
    const onHideRef = useRef();
    onHideRef.current = onHide;

    useEffect(() => {
        if (show === false) {
            if (onHideRef.current) onHideRef.current();
        }
    }, [show]);

    useEffect(() => {
        if (banner === false) {
            setShow(false);
        }
    }, [banner]);

    if (show && banner) {
        return (
            <Dialog open={show} maxWidth="lg">
                <form onSubmit={() => setShow(false)}>
                    <DialogTitle>
                        <Trans>nGeniusPULSE Security Message</Trans>
                    </DialogTitle>

                    <DialogContent>
                        <div className={classes.bannerText}>{banner || ''}</div>
                    </DialogContent>

                    <DialogActions>
                        <Button type="submit" ref={(el) => el && el.focus()} disableFocusRipple>
                            <Trans>Agree</Trans>
                        </Button>
                    </DialogActions>
                </form>
            </Dialog>
        );
    }

    return null;
}

export function useWarningBanner() {
    const dataService = useDataService();
    const { data: banner, methods } = useRequestState();

    useEffect(() => {
        doGet();

        async function doGet() {
            methods.onInit();
            const { enabled, message } = await dataService.get(BANNER_URL);

            methods.onLoad(enabled && message ? message : false);
        }
    }, [dataService, methods]);

    return { banner };
}
